import { render, staticRenderFns } from "./AgentEmpty.vue?vue&type=template&id=4bf28866&scoped=true"
import script from "./AgentEmpty.vue?vue&type=script&lang=js"
export * from "./AgentEmpty.vue?vue&type=script&lang=js"
import style0 from "./AgentEmpty.vue?vue&type=style&index=0&id=4bf28866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf28866",
  null
  
)

export default component.exports